import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ISnListQueryParameters } from '@lib/api';

import { LprStats } from '../../models/lpr-stats.model';

@Injectable({
  providedIn: 'root',
})
export class LprAggregationsAPI {
  constructor(private readonly _httpClient: HttpClient) {}

  public getLprResultsPerCamera(
    cameraName: string,
    mode?: string,
    timeEnd?: number,
    timeStart?: any,
  ): Observable<LprStats> {
    const params: ISnListQueryParameters = {
      camera_name: cameraName,
      mode,
      time_end: timeEnd,
      time_start: timeStart,
      zeroes: true,
    };

    return this._httpClient
      .get('/api/lpr/aggregations/reads/camera/', { params })
      .pipe(map((response) => new LprStats(response, mode)));
  }
}
